import AssetManagementPage from '../../components/assetManagement/AssetManagementPage';

import Icon from '../../assets/icon-assetmgmt.svg?react';

import createRoute from './create/routes';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

export default {
	relativePath: 'assetmanagement',
	label: {
		id: 'route.label.assetmanagement',
		defaultValue: 'Asset Management'
	},
	iconSvg: Icon,
	component: AssetManagementPage,
	requiredAuthorities: ['READ_MIGRATION'],
	config: {
		sidebarIndex: 4
	},
	childRoutes: [createRoute]
} satisfies RouteConfig;
